import { Injectable, inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { map } from 'rxjs/operators';
import { UserFunction } from '../entities/user-functions.entity';
import { UserService } from '../services/user.service';
import { UserFunctionCheck, UserFunctionGuard } from './userfunction.guard';

@Injectable({ providedIn: 'root' })
export class AdminGuard extends UserFunctionGuard {
    protected redirectUrl = '/forbidden';

    protected FUNCTIONS_TO_CHECK: UserFunction[] = [
        UserFunction.adminUsers,
        UserFunction.adminEditAllOrganisations,
        UserFunction.adminViewAllOrganisations,
        UserFunction.adminAllRoles,
        UserFunction.adminLinkRoles,
        UserFunction.adminExports,
        UserFunction.adminFilters,
        UserFunction.adminGroups,
        UserFunction.adminZones,
        UserFunction.adminWebsite,
        UserFunction.adminFieldDefinitions,
        UserFunction.adminProfiles,
        UserFunction.viewReports
    ];

    protected USER_FUNCTION_CHECK: UserFunctionCheck = UserFunctionCheck.HasAny;

    constructor(
        protected userService: UserService,
        protected router: Router
    ) {
        super(userService, router);
    }
}

// This is the 'hip' way of doing things now apparently
export const ForbiddenGuard: CanActivateFn = () => {
    const guard: AdminGuard = inject(AdminGuard);
    const router: Router = inject(Router);
    return guard.hasAccess().pipe(map(allowed => (allowed ? router.createUrlTree(['/']) : true)));
};
